import * as Yup from 'yup'

export const validationSchema = t => {
    return {
        date: Yup.string().required(),
        dateFrom: Yup.date()
            .min(new Date(2000, 0, 1), t('validation.date.unallowed'))
            .max(new Date(), t('validation.date.nofuture'))
            .transform(val => (!val ? '' : val))
            .when('date', {
                is: v => v === 'custom',
                then: Yup.date().required(t('validation.req.startdate')),
            }),
        dateTo: Yup.date()
            .max(new Date(), t('validation.date.nofuture'))
            .when('date', {
                is: v => v === 'custom',
                then: Yup.date()
                    .when('dateFrom', {
                        is: v => Boolean(v),
                        then: Yup.date().min(
                            Yup.ref('dateFrom'),
                            t('validation.startdate.enddate')
                        ),
                    })
                    .required(t('validation.req.enddate')),
            }),
        tag: Yup.array().min(1, t('validation.select.tag')),
    }
}
